export default __webpack_public_path__ + "static/media/img-6.a8aa1aff.png";